import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useFormikContext } from 'formik';
import React from 'react'

export default function NormalTextArea({label, name, placeholder, boxClassName, value, onChange, icon, disabled, rows}) {

  return (
    <div className={`my-3 ${boxClassName}`}>
        <label className="block text-gray-700 text-sm mb-2 capitalize" for="bio">
           {label||name}
        </label>
        <div className='flex w-full items-center shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 
                leading-tight'>
          <FontAwesomeIcon className='mr-2 text-theme/80' size='lg' icon={icon} />
        <textarea
            disabled={disabled} 
            name={name} 
            placeholder={placeholder}
            value={value}
            onChange={onChange} 
            rows={rows||"2"} className='w-full focus:outline-none focus:shadow-outline'
        ></textarea>
        </div>
    </div>
  )
}
